import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export class UserAccessRight {
  public static VIEW_USERS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel <= 1;
  public static REASSIGN_USERS: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
  public static VIEW_ACCESS_LEVEL: AuthenticationAccessRight = ({
    menuDisplayLevel,
  }) => menuDisplayLevel === 0;
}
